import React from "react";
import {Image} from 'antd'
import {Header} from "antd/es/layout/layout";
import Logo from 'asset/icons/paipoint_logo_color2.svg'
import './index.scss'

const PaiPointHeader: React.FC = () => {

    return (
        <div className={'pai-point-header-container'}>
            <Header style={{ padding: 0, background: '#ffffff' }}>
                <div className={'logo-container'}>
                    <div className={'logo-and-title'}>
                        <div className={'logo'}>
                            <Image width={42} src={Logo} preview={false} />
                        </div>
                        <div className={'title'}>
                            派点软件
                        </div>
                    </div>
                </div>
            </Header>
        </div>
    )
}

export default PaiPointHeader